import * as z from "zod/v4";

const SenderEmailSchema = z.object({
  email: z.string().email(),
  name: z.string(),
  postmarkId: z.number(),
  domainId: z.number(),
  dkimHost: z.string(),
  dkimText: z.string(),
  returnPathDomain: z.string(),
  returnPathValue: z.string(),
  setupStatus: z.string().nullish(),
});

export const updateSenderEmail = {
  name: "updateSenderEmail" as const,
  input: z.object({ senderEmail: SenderEmailSchema }),
  output: z.object({ senderEmails: z.array(SenderEmailSchema) }),
};
